import { useEffect, useRef } from 'react';
import { useReward } from '@/contexts/reward-context';
import { TooltipProps } from '@/types';

export const Tooltip = ({
	isShowingDetail,
	setIsShowingDetail,
	rewardName,
	children,
	triggerRef
}: TooltipProps) => {
	const tooltip = useRef<HTMLDivElement>(null);
	const { labels } = useReward();

	const isInsideElement = (el: HTMLElement | null, x: number, y: number) => {
		if (!el) return false;
		const rect = el.getBoundingClientRect();
		return rect.left <= x && x <= rect.left + rect.width && rect.top <= y && y <= rect.top + rect.height;
	};

	const checkOutsideClick = (event: MouseEvent) => {
		if (!tooltip.current) return;
		const { clientX, clientY } = event;
		const insideTooltip = isInsideElement(tooltip.current, clientX, clientY); // 檢查點是否在 tooltip 內
		const insideTrigger = triggerRef?.current && isInsideElement(triggerRef.current, clientX, clientY); // 檢查點是否在 click 在info icon上，如果是在info icon上，由外部的toggle處理
		if (!insideTooltip && !insideTrigger) {
			setIsShowingDetail(false);
		}
	};
	useEffect(() => {
		if (!isShowingDetail) {
			window.removeEventListener('click', checkOutsideClick, true);
			return;
		}
		const timeoutId = setTimeout(() => {
			window.addEventListener('click', checkOutsideClick, true);
		}, 500);

		return () => {
			clearTimeout(timeoutId);
			window.removeEventListener('click', checkOutsideClick, true);
		};
	}, [isShowingDetail]);

	return (
		<div
			className="reward-tooltip"
			ref={tooltip}
			onClick={(e) => e.stopPropagation()}
			data-show={isShowingDetail}
		>
			<div className="reward-tooltip__title">{rewardName ? labels?.[rewardName] : labels?.lbl_RPCycleChallenge}</div>
			<div className="reward-tooltip__text">{children}</div>
		</div>
	);
};
